import { Toaster as Sonner, toast, type ToasterProps } from 'sonner'

/**
 * Thông báo toàn ứng dụng. Đặt <Toaster /> MỘT lần ở App.tsx, rồi gọi
 * toast.success('...') / toast.error('...') ở bất cứ đâu.
 */
const Toaster = (props: ToasterProps) => (
  <Sonner
    className="toaster group"
    style={{
      '--normal-bg': 'var(--popover)',
      '--normal-text': 'var(--popover-foreground)',
      '--normal-border': 'var(--border)',
    } as React.CSSProperties}
    {...props}
  />
)

export { Toaster, toast }
